import { render, staticRenderFns } from "./ViewCandidateProfileDialog.vue?vue&type=template&id=340ee634&scoped=true&"
import script from "./ViewCandidateProfileDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewCandidateProfileDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCandidateProfileDialog.vue?vue&type=style&index=0&id=340ee634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ee634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow,VSkeletonLoader})
